module.exports = __webpack_public_path__ + "static/media/how_work_1.450d044a.svg";